import type { Shop } from '@aviata/platform-types';
import { useMutation } from '@tanstack/vue-query';

import { invalidateOrderQuery } from '@/entities/order';
import { useBill } from '@/entities/bill';

import { analyticsEventsLib } from '@/shared/lib';
import { api as pfmApi } from '@/shared/api';

export function useApplyPromocodeMutation(orderId: string, billId: string) {
  const { refetch: refetchBill } = useBill({ orderId });

  return useMutation({
    mutationKey: ['promocodes', 'apply', billId],
    mutationFn(promocode: string) {
      return pfmApi.client.post<Shop.PriceModifier.Promocode['data']>(
        'promocodes/apply',
        {
          promocode,
          bill_id: billId,
        },
      );
    },
    onSuccess(_data, promocode) {
      analyticsEventsLib.promocodeApplied({ value: promocode });
      refetchBill();
      invalidateOrderQuery(orderId);
    },
  });
}
